import { render } from "./Index.vue?vue&type=template&id=0625cae0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=0625cae0&lang=scss&scoped=true"

import exportComponent from "E:\\xlckj\\大屏\\monitor\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0625cae0"]])

export default __exports__